import { createUseStyles } from 'react-jss'

const headerHeight = 80

export const style = {
  pageLayoutContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    paddingBottom: 40,
    width: '100%',
    maxWidth: 1200
  },
  readOnlyMarginTop: {
    marginTop: headerHeight
  },
  marginBelowControlBar: {
    marginTop: 15
  }
}

export const useStyles = createUseStyles(style)
